import {PAEnvironment} from "../PA.Core/PAEnvironment";
import axios from 'axios';
import {
    DataSetPart, IActualPredictedUnits,
    IMAPEPrdGrpSummaryRequest,
    IModelingScorecardService,
    ISummaryMetricsRequest,
    IWeightedMAPEByCustomer, IWeightedMAPEByPPG,
    IWeightedMAPEByProduct, MapeRange
} from "./ModelingScorecardService.IF";


export class ModelingScorecardService
    implements
        IModelingScorecardService
{

    getSummarySalesMetrics(arrWbModelingSessionIds: number[], mapeRanges:  MapeRange[], dataSetParts: DataSetPart[]): Promise<{mapeRange: MapeRange, retailSales: number}[]> {
        let aRequest: ISummaryMetricsRequest = {
            RequestType: "SummarySalesMetrics",
            modelingSessionIds: arrWbModelingSessionIds,
            mapeRanges:  mapeRanges,
            dataSetParts: dataSetParts

        };

        return this.makeRequest(aRequest)
    }

    getSummaryCustPPGMetrics(arrWbModelingSessionIds: number[], mapeRanges:  MapeRange[], dataSetParts: DataSetPart[]): Promise<{mapeRange: MapeRange, DistinctCustomerProducts: number}[]> {
        let aRequest: ISummaryMetricsRequest = {
            RequestType: "SummaryCustPPGMetrics",
            modelingSessionIds: arrWbModelingSessionIds,
            mapeRanges:  mapeRanges,
            dataSetParts: dataSetParts

        };

        return this.makeRequest(aRequest)
    }

    getModelingSessionMAPECustomerSummary(arrWbModelingSessionIds: number[], mapeRange:  MapeRange, dataSetParts: DataSetPart[], arrWBCustIds?: number[]): Promise<IWeightedMAPEByCustomer[]> {
        let aRequest: any = {
            RequestType: "MAPECustomerSummary",
            modelingSessionIds: arrWbModelingSessionIds,
            mapeRange:  mapeRange,
            dataSetParts: dataSetParts,
            customerIds: arrWBCustIds
        };

        return this.makeRequest(aRequest)
    }

    getModelingSessionMAPEProductSummary(arrWbModelingSessionIds: number[], mapeRange:  MapeRange, dataSetParts: DataSetPart[], arrWBCustIds?: number[], hierarchyLevel?: string): Promise<IWeightedMAPEByProduct[]> {
        let aRequest: any = {
            RequestType: "MAPEProductSummary",
            modelingSessionIds: arrWbModelingSessionIds,
            mapeRange:  mapeRange,
            dataSetParts: dataSetParts,
            customerIds: arrWBCustIds,
            hierarchyLevel: hierarchyLevel
        };

        return this.makeRequest(aRequest)
    }

    getModelingSessionMAPEPrdGrpSummary(arrWbModelingSessionIds: number[], mapeRange:  MapeRange, dataSetParts: DataSetPart[], arrWBCustIds?: number[], wbPrdGrpIds?: number[], wbPrdIds_Leaf?: number[]): Promise<IWeightedMAPEByPPG[]> {
        let aRequest: IMAPEPrdGrpSummaryRequest = {
            RequestType: "MAPEProductGroupSummary",
            modelingSessionIds: arrWbModelingSessionIds,
            mapeRange:  mapeRange,
            dataSetParts: dataSetParts,
            customerIds: arrWBCustIds,
            productIds: wbPrdGrpIds,
            productLeafIds: wbPrdIds_Leaf
        };

        return this.makeRequest(aRequest)
    }

    getModelingSessionActualPredictedUnits(arrWbModelingSessionIds: number[], mapeRange:  MapeRange, dataSetParts: DataSetPart[], arrWBCustIds?: number[], wbPrdGrpIds?: number[], wbPrdIds_Leaf?: number[]): Promise<IActualPredictedUnits[]> {
        let aRequest: any = {
            RequestType: "ActualPredictedUnits",
            modelingSessionIds: arrWbModelingSessionIds,
            mapeRange:  mapeRange,
            dataSetParts: dataSetParts,
            customerIds: arrWBCustIds,
            productIds: wbPrdGrpIds,
            productLeafIds: wbPrdIds_Leaf
        };

        return this.makeRequest(aRequest)
    }

    getModelingSessionKPISummary(arrWbModelingSessionIds: number[], mapeRange?:  MapeRange, dataSetParts?: DataSetPart[], arrWBCustIds?: number[], wbPrdGrpIds?: number[], wbPrdIds_Leaf?: number[]): Promise<{mapeTraining: number, mapeHoldout: number}> {
        let aRequest: any = {
            RequestType: "KPISummary",
            modelingSessionIds: arrWbModelingSessionIds,
            mapeRange:  mapeRange,
            dataSetParts: dataSetParts,
            customerIds: arrWBCustIds,
            prdGrpIds: wbPrdGrpIds,
            productLeafIds: wbPrdIds_Leaf
        };

        return this.makeRequest(aRequest)
    }


    private makeRequest(aRequest: any): Promise<any> {
        return new Promise<any>((resolve, error) => {
            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base), "/");
            if (sEndPoint.endsWith('/')) {
                sEndPoint += 'modelingScorecardService';
            } else {
                sEndPoint += '/modelingScorecardService';
            }

            axios.post(sEndPoint, {data: {request: aRequest}})
                .then((resp: any) => {
                    let responseData = resp.data;
                    resolve(responseData);
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

}